<tt-card *ngIf="!!get">
    <ng-container *ngIf="!loading">
        <tt-input ttLabel="p2_webpage_table_keyno" [(ttModel)]="get.p2_webpage_table_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="webpage_name" [(ttModel)]="get.webpage_name" ttReadonly></tt-input>
        <tt-input ttLabel="table_name" [(ttModel)]="get.table_name" ttReadonly></tt-input>
        <tt-checkbox ttLabel="include" [(ttModel)]="get.include"></tt-checkbox>
        <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    </ng-container>
    <ng-container *ngIf="loading">
        <div class="col-xs-12 sp-0 tt-skeleton" style="height: var(--tt-height); margin-bottom: 7px"></div>
        <div class="col-xs-12 sp-0 tt-skeleton" style="height: var(--tt-height); margin-bottom: 7px"></div>
        <div class="col-xs-12 sp-0 tt-skeleton" style="height: var(--tt-height); margin-bottom: 7px"></div>
        <div class="col-xs-12 sp-0 tt-skeleton" style="height: var(--tt-height); margin-bottom: 7px"></div>
        <div class="tt-skeleton col-xs-12 sp-0" style="height: var(--tt-height); background-color: var(--tt-success-color); margin-bottom: 7px"></div>
    </ng-container>
</tt-card>
